import type { UserValidationPayload } from '@/types/onboarding/UserValidationPayload';

interface UserNameClaims {
  given_name?: string;
  family_name?: string;
  // Keycloak's parsed token type carries other unrelated claims via its own
  // index signature; matching it here keeps the two types structurally
  // compatible without needing a cast at every call site.
  [key: string]: unknown;
}

/**
 * Builds the payload for `startUserVerification` from a Keycloak user's name
 * claims. Mononymous users may have only one of `given_name` / `family_name`
 * set on their token; the API requires both fields to always be present, so
 * a missing name part is sent as an empty string rather than omitted.
 */
export function buildUserValidationPayload(
  user: UserNameClaims | null | undefined
): UserValidationPayload {
  return {
    firstNames: user?.given_name ?? '',
    lastName: user?.family_name ?? ''
  };
}
